import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_2 = { class: "border border-gray-200 rounded-xl p-6" }
const _hoisted_3 = { class: "mt-2 text-3xl font-bold text-gray-900" }
const _hoisted_4 = { class: "border border-gray-200 rounded-xl p-6" }
const _hoisted_5 = { class: "mt-2 text-3xl font-bold text-gray-900" }
const _hoisted_6 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_7 = { class: "border border-gray-200 rounded-xl p-6" }
const _hoisted_8 = { class: "mt-2 text-3xl font-bold text-gray-900" }
const _hoisted_9 = { class: "text-gray-400" }
const _hoisted_10 = {
  key: 0,
  class: "mt-1 text-sm text-gray-500"
}

import { computed } from 'vue'


export default {
  __name: 'AgentsSummaryTiles',
  props: {
  aggregates: { type: Object, required: true },
  activeCount: { type: Number, required: true },
  slotCount: { type: Number, required: true }
},
  setup(__props) {

const props = __props

const formattedSales = computed(() => `$${((props.aggregates.sales_driven_cents || 0) / 100).toFixed(2)}`)

const salesDelta = computed(() => {
  const prior = props.aggregates.sales_driven_prior_cents
  if (!prior) return null
  return (props.aggregates.sales_driven_cents - prior) / prior
})

const deltaPercent = computed(() => Math.abs(Math.round((salesDelta.value || 0) * 100)))

const agentWord = computed(() => (props.activeCount === 1 ? 'agent' : 'agents'))

const notSetUp = computed(() => Math.max(props.slotCount - props.activeCount, 0))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-xs uppercase tracking-wider text-gray-500" }, "Sales driven · 30D", -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(formattedSales.value), 1),
      (salesDelta.value !== null)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["mt-1 text-sm font-medium", salesDelta.value >= 0 ? 'text-green-600' : 'text-red-600'])
          }, _toDisplayString(salesDelta.value >= 0 ? '↑' : '↓') + " " + _toDisplayString(deltaPercent.value) + "% vs. prior 30d ", 3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-xs uppercase tracking-wider text-gray-500" }, "Conversations · 30D", -1)),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.aggregates.conversations_count), 1),
      _createElementVNode("div", _hoisted_6, "across " + _toDisplayString(__props.activeCount) + " active " + _toDisplayString(agentWord.value), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-xs uppercase tracking-wider text-gray-500" }, "Agents active", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createTextVNode(_toDisplayString(__props.activeCount) + " ", 1),
        _createElementVNode("span", _hoisted_9, "of " + _toDisplayString(__props.slotCount), 1)
      ]),
      (notSetUp.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(notSetUp.value) + " " + _toDisplayString(notSetUp.value === 1 ? 'agent' : 'agents') + " not set up yet ", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}